export const HeadlineText = type => {
    switch (type) {
      case "start":
        return "Application for private Google Ads coaching"
      case "yourself":
        return "Tell me more about yourself"
      case "brand":
        return "Tell me more about your business"
      case "confirm":
        return "Information"
      case "thank-you":
        return "Thank you"
    }
  }
  
  export const StateReducer = (state, action) => {
    switch (action.type) {
      case "field": {
        state[action.field] = action.value
        return { ...state }
      }
      default:
        return { ...state }
    }
  }
  